<template>
  <div class="databases-table-wrapper px-2 d-flex flex-grow-1 flex-wrap">
    <div v-if="document.fraud_results" class="d-flex my-4 mx-auto flex-column">
      <h6 class="mb-2">Blocklists</h6>
      <div>
        <b-table
          ref="blocklistsTable"
          :fields="blocklistFields"
          :responsive="true"
          :show-empty="true"
          :items="
            generateBlocklistResultsTable(
              document.fraud_results.blacklists.details.pages,
            )
          "
          class="ui-table blocklists-table card"
        >
          <template #cell(blocklist_item)="{ item: { type, blacklist } }">
            <div>
              <label :class="[{ 'highlight-bl-item': type === 'Name' }, '']"
                >Name:</label
              >
              <span :class="[{ 'highlight-bl-item': type === 'Name' }, '']">{{
                blacklist.name
              }}</span>
              <label :class="[{ 'highlight-bl-item': type === 'Address' }, '']"
                >Address:</label
              >
              <span
                :class="[{ 'highlight-bl-item': type === 'Address' }, '']"
                >{{ blacklist.address.normalized }}</span
              >
            </div>
          </template>

          <template #empty>
            <h6>No blocklisted properties were found in this document</h6>
          </template>
        </b-table>
      </div>
      <h6 class="mt-5 mb-2">Rejected customers with this address</h6>
      <div>
        <b-table
          ref="rejectedCustomerTable"
          :fields="rejectedCustomerFields"
          :responsive="true"
          :show-empty="true"
          :items="
            document.fraud_results.rejected_customer.details.rejected_details
          "
          class="ui-table rejected-customer-table card"
        >
          <template #empty>
            <h6>No rejected customers with these details</h6>
          </template>
          <template #cell(customer)="{ item: { customer } }">
            <router-link v-if="customer.id" :to="`customer/${customer.id}`">
              <span>{{ customer.name }}</span>
            </router-link>
          </template>
          <template #cell(address)="{ item: { address } }">
            <div class="filename">{{ address }}</div>
          </template>
        </b-table>
      </div>
      <h6 class="mt-5 mb-2">Templates</h6>
      <div>
        <b-table
          ref="templatesTable"
          :fields="templateFields"
          :responsive="true"
          :show-empty="true"
          :items="document.fraud_results.templates.details.pages"
          class="ui-table templates-table card"
        >
          <template #empty>
            <h6>The document doesn't match any templates on file</h6>
          </template>
          <template #cell(matched_template_name)="{ item: template }">
            <div class="filename">{{ template.matched_template_name }}</div>
          </template>
        </b-table>
      </div>
    </div>
    <div v-else class="d-flex w-100 align-items-center justify-content-center">
      <i-spinner></i-spinner>
    </div>
  </div>
</template>

<script>
import format from '../../format';
import { iSpinner } from '@inscribe/signal';

export default {
  components: {
    iSpinner,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      format,
      blocklistFields: [
        { key: 'page_number' },
        { key: 'matched_text' },
        { key: 'type' },
        {
          key: 'blocklist_item',
        },
      ],
      rejectedCustomerFields: [
        { key: 'customer', tdClass: 'fs-exclude' },
        {
          key: 'address',
          tdClass: 'text-right',
          thClass: 'text-right',
        },
      ],
      templateFields: [
        { key: 'matched_template_name', tdClass: 'fs-exclude' },
        { key: 'similarity', tdClass: 'text-right', thClass: 'text-right' },
        { key: 'page_number', tdClass: 'text-right', thClass: 'text-right' },
      ],
    };
  },
  computed: {},
  methods: {
    generateBlocklistResultsTable(pages) {
      return pages.reduce(
        (pageAcc, page) => [
          ...pageAcc,
          ...page.instances.reduce(
            (instanceAcc, instance) => [
              ...instanceAcc,
              {
                id: page.page_id,
                page_number: page.page_number,
                ...instance,
                type: this.capitalizeFirstLetter(instance.type),
                blocklist_item:
                  instance.type === 'NAME'
                    ? instance.blacklist.name
                    : instance.blacklist.address.normalized,
              },
            ],
            [],
          ),
        ],
        [],
      );
    },
    capitalizeFirstLetter(word) {
      const lower = word.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    },
  },
};
</script>

<style lang="scss">
.databases-table-wrapper {
  overflow: auto;
  max-height: 100%;

  div {
    max-width: 800px;
    width: 100%;
  }

  td {
    white-space: nowrap;
  }

  .document-name {
    max-width: 400px;

    .truncated-filename span {
      color: $color-dark-blue-80;
    }
  }

  .highlight-bl-item {
    font-weight: bold;
  }
}
</style>
